export default "__VITE_ASSET__bXS57xKI__"